import { createFileRoute } from "@tanstack/react-router";

import { legalFacts } from "@/features/legal/utils/legal-facts";
import { LegalDocumentPage } from "@/features/legal/components/legal-page";
import { pageMeta } from "@/lib/seo";
import { m } from "@/paraglide/messages.js";

export const Route = createFileRoute("/(public)/withdrawal/")({
  // Out of search until `legalEntity` holds the real company details.
  staticData: { sitemap: false },
  head: () => ({ meta: pageMeta({ title: m.legal_withdrawal_title(), description: m.legal_withdrawal_description() }) }),
  loader: () => ({ crumb: m.legal_withdrawal_title() }),
  component: () => <LegalDocumentPage title={m.legal_withdrawal_title()} source={m.legal_withdrawal_body(legalFacts())} />,
});
